<template>
  <nav aria-label="Content">
    <ul class="flex">
      <li
        v-for="(slide, i) in slides"
        :key="slide.slug"
      >
        <RouterLink
          :to="slide.slug"
          :title="slide.title"
          class="block p-2 lg:p-3 rounded-full group focus-a"
        >
          <span
            class="block h-2 md:h-3 w-2 md:w-3 rounded-full border border-primary"
           :class="{
              'bg-primary border-primary': active === slide.slug,
              'group-hover:bg-primary': !touch
            }"
          />
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'FpNavDotsSlide',

  props: {
    slides: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapState([ 'touch', 'mobile' ]),
    ...mapGetters([ ]),

    active() {
      if (this.$route.params.panorama_id) {
        return this.$route.params.panorama_id
      }

      return this.$route.params.media_id
    }
  }
}
</script>
